import {
	Alert,
	Box,
	Button,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	OutlinedInput,
	Typography,
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { useState, useEffect } from 'react'
import { useGetCompanyAccessQuery } from '../../store/api/backoffice/backofficeApi'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setCompanyAccess } from '../../store/slices/backoffice/backofficeCompanyAccessSlice'
import { RootState } from '../../store/store'

function BackOfficeCompanyBD() {
	const location = useLocation()
	const dispatch = useDispatch()
	const [showValues, setShowValues] = useState(false)
	const { data: companyAccess } = useGetCompanyAccessQuery(location.state.companyDatabaseId)
	const companyAccessSelector = useSelector((state: RootState) => state.backofficeCompanyAccess)

	useEffect(() => {
		if (companyAccess) {
			dispatch(setCompanyAccess(companyAccess))
		}
	}, [companyAccess])

	const handleShowValues = () => {
		setShowValues(!showValues)
	}

	const handleChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
		if (companyAccessSelector.data) {
			dispatch(
				setCompanyAccess({
					...companyAccessSelector,
					data: {
						...companyAccessSelector.data,
						[field]: event.target.value || '',
					},
				}),
			)
		}
	}

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', marginBlockStart: '1rem' }}>
			<Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', width: '85%' }}>
				<Typography
					sx={{ paddingBlock: '0.2rem' }}
					variant='h5'
				>
					Configurações Entra ID (AD)
				</Typography>

				{/* Configurações Entra ID */}
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginBottom: 3 }}>
					<FormControl size='small'>
						<InputLabel>App ID</InputLabel>
						<OutlinedInput
							value={companyAccessSelector.data?.appId || ''}
							onChange={handleChange('appId')}
							label='App ID'
							type={showValues ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position='end'>
									<IconButton onClick={handleShowValues}>
										<VisibilityIcon />
									</IconButton>
								</InputAdornment>
							}
						/>
					</FormControl>

					<FormControl size='small'>
						<InputLabel>Tenant de Autenticação</InputLabel>
						<OutlinedInput
							value={companyAccessSelector.data?.tenants || ''}
							onChange={handleChange('tenants')}
							label='Tenant de Autenticação'
							type={showValues ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position='end'>
									<IconButton onClick={handleShowValues}>
										<VisibilityIcon />
									</IconButton>
								</InputAdornment>
							}
						/>
					</FormControl>

					<FormControl size='small'>
						<InputLabel>Audience ID</InputLabel>
						<OutlinedInput
							value={companyAccessSelector.data?.audienceId || ''}
							onChange={handleChange('audienceId')}
							label='Audience ID'
							type={showValues ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position='end'>
									<IconButton onClick={handleShowValues}>
										<VisibilityIcon />
									</IconButton>
								</InputAdornment>
							}
						/>
					</FormControl>

					<FormControl size='small'>
						<InputLabel>Secret</InputLabel>
						<OutlinedInput
							value={companyAccessSelector.data?.secret || ''}
							onChange={handleChange('secret')}
							label='Secret'
							type={showValues ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position='end'>
									<IconButton onClick={handleShowValues}>
										<VisibilityIcon />
									</IconButton>
								</InputAdornment>
							}
						/>
					</FormControl>

					<FormControl size='small'>
						<InputLabel>Audience ID Mobile</InputLabel>
						<OutlinedInput
							value={companyAccessSelector.data?.audienceIdMobile || ''}
							onChange={handleChange('audienceIdMobile')}
							label='Audience ID Mobile'
							type={showValues ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position='end'>
									<IconButton onClick={handleShowValues}>
										<VisibilityIcon />
									</IconButton>
								</InputAdornment>
							}
						/>
					</FormControl>

					<FormControl size='small'>
						<InputLabel>Secret Mobile</InputLabel>
						<OutlinedInput
							value={companyAccessSelector.data?.secretMobile || ''}
							onChange={handleChange('secretMobile')}
							label='Secret Mobile'
							type={showValues ? 'text' : 'password'}
							endAdornment={
								<InputAdornment position='end'>
									<IconButton onClick={handleShowValues}>
										<VisibilityIcon />
									</IconButton>
								</InputAdornment>
							}
						/>
					</FormControl>
				</Box>

				{/* Configurações de Banco de Dados */}
				<Typography
					sx={{ paddingBlock: '0.4rem' }}
					variant='h6'
				>
					Base de Dados e Conectividade
				</Typography>

				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
						<FormControl
							size='small'
							sx={{ flex: 1 }}
						>
							<InputLabel>BD T1</InputLabel>
							<OutlinedInput
								value={companyAccessSelector.data?.databaseName || ''}
								onChange={handleChange('databaseName')}
								label='BD T1'
								type={showValues ? 'text' : 'password'}
								endAdornment={
									<InputAdornment position='end'>
										<IconButton onClick={handleShowValues}>
											<VisibilityIcon />
										</IconButton>
									</InputAdornment>
								}
							/>
						</FormControl>
						<FormControl
							size='small'
							sx={{ flex: 1 }}
						>
							<InputLabel>BD T2</InputLabel>
							<OutlinedInput
								value={companyAccessSelector.data?.linkedServer || ''}
								onChange={handleChange('linkedServer')}
								label='Server T1'
								type={showValues ? 'text' : 'password'}
								endAdornment={
									<InputAdornment position='end'>
										<IconButton onClick={handleShowValues}>
											<VisibilityIcon />
										</IconButton>
									</InputAdornment>
								}
							/>
						</FormControl>
						<Button
							size='small'
							variant='contained'
						>
							Testar Conectividade
						</Button>
						<Typography variant='body1'>Status de Integração:</Typography>
						<Alert
							severity='success'
							sx={{
								padding: '0 16px',
								height: '37px',
								fontFamily: 'var(--font-family)',
								fontSize: '14px',
								fontWeight: 500,
								lettrerSpacing: '0.15px',
								lineHeight: '150%',
							}}
						>
							Conexão ativa
						</Alert>
					</Box>
				</Box>
			</Box>
		</Box>
	)
}

export default BackOfficeCompanyBD
